module.exports = __webpack_public_path__ + "static/media/LOGO-HOMME-TEXTE-NOIR.aac0ec6b.png";